function Vision() {
    let aboutLRIRight = "./assets/aboutLRIRight.png";
    return (
        <main className="about-page">
            <section id="about_lri" className="section-band">
                <div id="about_lri_left" className="section-copy">
                    <h1 className="section-title">Our Vision</h1>
                    <p>The intention behind living room inquires is as follows:</p>
                    <p>1. to expand our community of truth finders,<br></br>
                    2. share our experience In the work,<br></br>
                    3. support our invitees (that’s you) in navigating the questions,<br></br>
                    4. facilitate paradigm-shifting <i className="text-strong">epiphanies-on-purpose</i> that move you into a world of your greatest potential—all without planning, effort, or discipline.</p>
                </div>
                <img src={aboutLRIRight} id="about_lri_right" alt="" />
            </section>
        </main>
    );
}

export default Vision;
